<template>
  <div class="providers-page flex column">
    <HeaderCard :title="$t('left-menu.providers')" @open="openProviderEditor"></HeaderCard>
    <el-row class="mb-10 mt-0" :gutter="10">
      <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12" class="mb-5">
        <span v-if="selected.length==0 && !isFiltered" class="fs-14">Tous les producteurs <span><el-button icon="el-icon-plus" circle size="small" @click="openProviderEditor"></el-button></span></span>
        <span v-else>
          <span class="fs-14">Producteurs</span>
          <span v-if="!isFiltered">
            <span class="mr-10 fs-14"><i class="el-icon-arrow-right"></i> Sélectionné(s)</span><span class="bg-accent-lighter b-rad-18 p-8 fs-14">{{selected.length}}</span>
            <el-dropdown size="small" split-button type="primary" class="ml-20">
              Actions
              <el-dropdown-menu slot="dropdown">
               <el-dropdown-item @click.native="deleteSelectedProviders"><i class="el-icon-delete"></i>Supprimer</el-dropdown-item>
               <el-dropdown-item :disabled="true"><i class="mdi mdi-file-excel"></i>Exporté CSV</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </span>
          <span v-else>
            <span class="mr-10 fs-14"><i class="el-icon-arrow-right"></i> Résultats de recherche</span><span class="bg-accent-lighter b-rad-18 p-8 fs-14">{{cmsProviders.length}}</span>
          </span>
        </span>
      </el-col>
      <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
        <el-input
          placeholder="Rechercher un fournisseur"
          clearable
          size="small"
          v-model="searchModel"
          v-popover:popover>
          <el-badge slot="append" :value="activeFiltersCount" :hidden="activeFiltersCount === 0">
            <el-button icon="el-icon-s-operation" @click="filtersDrawerVisible = true" :type="hasActiveFilters ? 'primary' : ''"></el-button>
          </el-badge>
        </el-input>
      </el-col>
    </el-row>
    <!-- Drawer filtres -->
    <el-drawer
      title="Filtres"
      :visible.sync="filtersDrawerVisible"
      direction="rtl"
      :size="window.width < 480 ? '100%' : '320px'">
      <div class="p-20">
        <el-form label-position="top" size="small">
          <el-form-item label="Statut">
            <el-select :value="publishedFilter" @change="setPublishedFilter" placeholder="Tous" clearable style="width:100%">
              <el-option label="Publié" :value="true"></el-option>
              <el-option label="Non publié" :value="false"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Compagnie">
            <el-select :value="portausCompanyIdsFilter" @change="setPortausCompanyIdsFilter" placeholder="Toutes" multiple clearable style="width:100%">
              <el-option
                v-for="pc in portausCompanies"
                :key="pc.id"
                :label="pc.name"
                :value="pc.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Logo">
            <el-select :value="hasLogoFilter" @change="setHasLogoFilter" placeholder="Tous" clearable style="width:100%">
              <el-option label="Avec logo" :value="true"></el-option>
              <el-option label="Sans logo" :value="false"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Image principale">
            <el-select :value="hasMainImageFilter" @change="setHasMainImageFilter" placeholder="Toutes" clearable style="width:100%">
              <el-option label="Avec image principale" :value="true"></el-option>
              <el-option label="Sans image principale" :value="false"></el-option>
            </el-select>
          </el-form-item>
          <el-button size="small" @click="resetFilters">Réinitialiser</el-button>
        </el-form>
      </div>
    </el-drawer>
    <div class="providers-toolbar">
      <span class="fs-13 secondary-text">{{ (totalProducts || 0) + ' fournisseur' + ((totalProducts || 0) !== 1 ? 's' : '') + (hasActiveFilters ? ' (filtrés)' : '') }}</span>
      <Pagination
        class="box right mt-5 mb-0 fs-14 secondary-text"
        :current-page="localCurrentPage"
        :total-number-of-page="localTotalPages"
        @click-previous="fetchPreviousPage"
        @click-next="fetchNextPage" />
    </div>
    <div class="providers-table-wrap">
    <el-table
      class="providers-table"
      :data="filteredProviders"
      stripe
      @selection-change="handleSelectionChange"
      empty-text="Aucun producteur"
      height="100%"
      v-loading="loading"
      :style="'width:' + getTableWidth  + 'px'">
    <el-table-column
      type="selection"
      width="55">
    </el-table-column>
    <el-table-column
      prop="name"
      fixed="left"
      min-width="150"
      label="Nom du producteur">
      <template slot-scope="scope">
        <PortausLink :id="scope.row.id" path="/settings/CMS/providers/" :label="scope.row.name"></PortausLink>
      </template>
    </el-table-column>
    <el-table-column
      prop="published"
      resizable
      align="center"
      width="80"
      label="Publié">
      <template slot-scope="scope">
        <i v-if="scope.row.published" class="accent-text el-icon-success"></i>
        <i v-else class="el-icon-error"></i>
      </template>
    </el-table-column>
    <el-table-column
      prop="logo"
      resizable
      align="center"
      width="70"
      label="Logo">
      <template slot-scope="scope">
        <span v-if="logoExists(scope.row.galeries)">
          <i slot="reference" class="fs-18 mdi mdi-image-outline"> </i>
        </span>
      </template>
    </el-table-column>
    <el-table-column
      prop="mainImage"
      resizable
      align="center"
      width="100"
      label="Image princ.">
      <template slot-scope="scope">
        <span v-if="mainImageExists(scope.row.galeries)">
          <i slot="reference" class="fs-18 mdi mdi-image-outline"> </i>
        </span>
      </template>
    </el-table-column>
    <el-table-column
      prop="portausCompanies"
      min-width="140"
      label="Compagnies actives">
      <template slot-scope="scope">
        <span v-if="scope.row.portausCompanies && scope.row.portausCompanies.length > 0">
          <el-tag
            v-for="pc in scope.row.portausCompanies"
            :key="pc.id"
            size="mini"
            type="success"
            class="mr-5">
            {{ getPortausCompanyName(pc.id) }}
          </el-tag>
        </span>
        <span v-else class="secondary-text fs-12">Aucune</span>
      </template>
    </el-table-column>
    <el-table-column
      align="right"
      min-width="130"
      label="Dernière mise à jour">
      <template slot-scope="scope">
        <span style="margin-left: 10px">{{ _moment(scope.row.updatedDate) }}</span>
      </template>
    </el-table-column>
  </el-table>
  </div>
  </div>
</template>
<script>
import cmsAPI from '@/services/API/cmsAPI'
import HeaderCard from '@/components/header-card'
import Provider from './provider'
import moment from 'moment-timezone'
import PortausLink from '@/components/portaus-link'
import Promise from 'bluebird'
import Pagination from '@/components/pagination'
import { mapActions, mapState, mapGetters } from 'vuex';

export default {
	name: 'Providers',
	data() {
		return {
      selected: [],
      filtersDrawerVisible: false,
      window: {
        width: 0,
        height: 0
      },
		}
	},
  components: {
    HeaderCard,
    PortausLink,
    Pagination,
  },
  computed: {
    searchModel : {
      set(val){ this.setSearch(val)},
      get(){return this.search}
    },
    ...mapState('cmsProviders',['cmsProviders','search', 'loading', 'currentPage', 'totalPages','limit','totalProducts','publishedFilter','portausCompanyIdsFilter','hasLogoFilter','hasMainImageFilter']),
    ...mapGetters('cmsProviders',['isFiltered']),
    portausCompanies() {
      return this.$store.state.controlData.portausCompanies || [];
    },
    localCurrentPage() {
      return this.currentPage;
    },
    localTotalPages() {
      return this.totalPages;
    },
    activeFiltersCount() {
      let count = 0;
      if (typeof this.publishedFilter === 'boolean') count++;
      if (this.portausCompanyIdsFilter && this.portausCompanyIdsFilter.length > 0) count++;
      if (typeof this.hasLogoFilter === 'boolean') count++;
      if (typeof this.hasMainImageFilter === 'boolean') count++;
      return count;
    },
    hasActiveFilters() {
      return this.activeFiltersCount > 0;
    },
    filteredProviders() {
      return this.cmsProviders;
    },
  },
  methods : {
    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
    },
    getTableWidth() {
      const w = this.window.width - 320;
      return w > 400 ? w : this.window.width;
    },
    logoExists(images) {
      let exists = false;
      _.forEach(images, img => {
        if (img.isProviderLogo) {
          exists = true;
        }
      })
      return exists;
    },
    mainImageExists (images) {
      let exists = false;
      _.forEach(images, img => {
        if (img.isProviderMainImage === true) {
          exists = true;
        }
      })
      return exists;
    },
    getLogoThumbnailLink (images) {
      const logo = _.find(images, i => i.isProviderLogo);
      return _.get(logo, 'thumbnailLink');
    },
    mainImageExists(images) {
      let exists = false;
      _.forEach(images, img => {
        if (img.isProviderMainImage) {
          exists = true;
        }
      })
      return exists;
    },
    deleteSelectedProviders(){
      this.$confirm('Êtes vous sûr de vouloir supprimer les producteurs sélectionnés?', 'Warning', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Annuler',
          type: 'warning'
        }).then(()=>{
          return Promise.each(this.selected, p=>{
            return cmsAPI.deleteProvider(p.id);
          }).then(()=>this.refreshProviders())
        }).catch(err=>{
          if(err=="cancel"){
            this.$message('Suppression annulée!');
          }else{
            console.log(err);
            this.$message.error('Une erreur est survenue. Veuillez réessayer plus tard');
          }
        })
    },
    _moment(datetime, format='l'){
      return moment(datetime).format(format);
		},
    getPortausCompanyName(id) {
      const pc = _.find(this.portausCompanies, c => c.id === id);
      return pc ? pc.name : id;
    },
    applyFilters() {
      // Le computed filteredProviders réagit automatiquement aux changements de localFilters
    },
    resetFilters() {
      this.setPublishedFilter(null);
      this.setPortausCompanyIdsFilter([]);
      this.setHasLogoFilter(null);
      this.setHasMainImageFilter(null);
    },
    openProviderEditor(){
      this.$router.push('/settings/CMS/provider');
    },
    refreshProviders(){
      this.fetchCMSProviders();
    },
    handleSelectionChange(val){
      this.selected = val;
    },
    ...mapActions('cmsProviders',['fetchCMSProviders','setSearch','setPublishedFilter','setPortausCompanyIdsFilter','setHasLogoFilter','setHasMainImageFilter', 'fetchPreviousPage', 'fetchNextPage']),
    ...mapActions('controlData', ['fetchPortausCompany']),
  },
  mounted(){
    this.fetchCMSProviders();
    this.fetchPortausCompany();
  },
  created(){

    window.addEventListener('resize', this.handleResize)
    this.handleResize();
	},
  destroyed() {
    window.removeEventListener('resize', this.handleResize)
  }
}
</script>
<style lang="scss" scoped>
@import '../../../assets/scss/_variables';

.providers-page {
  height: 100%;
  min-height: 0;
}

.providers-toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 10px 0;
  flex-shrink: 0;
}

.providers-table-wrap {
  flex: 1;
  min-height: 0;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

.providers-table {
  min-height: 100%;
}

@media (max-width: 768px) {
  .providers-toolbar {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
}

</style>
